import { SVGProps } from 'react'

import { wrapIcon } from '../wrap-icon'

function SvgCornerDownRight(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.008 3a1 1 0 0 1 1 1v2.5c0 .304-.113 2.233.564 4.096.334.916.84 1.758 1.596 2.369.741.6 1.795 1.035 3.34 1.035h7.086L14.3 10.707a1 1 0 1 1 1.414-1.414l5 5a1.003 1.003 0 0 1 .249.414l.016.062a.994.994 0 0 1-.265.938l-5 5-.076.068a1 1 0 0 1-1.407-1.406l.069-.076L17.594 16h-7.086c-1.955 0-3.464-.564-4.598-1.48-1.119-.905-1.8-2.095-2.217-3.24-.416-1.146-.584-2.29-.651-3.165a14.602 14.602 0 0 1-.038-1.46c0-.044.002-.084.003-.111V4a1 1 0 0 1 1-1Z"
        fill="currentColor"
      />
    </svg>
  )
}
export default wrapIcon(SvgCornerDownRight)
